import { cssColorValue, screenSmMax, screenXsMax, cssSpacing, } from '@spotify-internal/encore-web';
import styled, { css } from 'styled-components';
import { ImageAspectBox16x9 } from '../ImageAspectBox/ImageAspectBox';
import { transformScaleUp } from '../../utils';
export const ImageWrapper = styled(ImageAspectBox16x9) `
  overflow: hidden;

  /* Add a subtle gradient overlay for videos to make the play button more visible
     This creates a dark shadow at the bottom of video thumbnails */
  ${props => props.video &&
    css `
      &::before {
        content: '';
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        box-shadow: inset 0 -90px 10px 0 rgba(0, 0, 0, 0.1);
        z-index: 2;
      }
    `}

  /* Play icon styling - only shown for video content */
  svg {
    /* Hide play icon for non-video content */
    display: ${props => (props.video ? 'initial' : 'none')};
    position: absolute;

    /* Position based on featured status - featured items get larger icons with more spacing */
    bottom: ${props => props.featured ? cssSpacing('looser') : cssSpacing('base')};
    left: ${props => props.featured ? cssSpacing('looser') : cssSpacing('base')};

    /* Icon size based on featured status */
    width: ${props => (props.featured ? '48px' : '32px')};
    height: auto;
    color: ${cssColorValue('backgroundBase')};
    z-index: 3;

    /* Responsive adjustments for smaller screens */
    @media (max-width: ${screenXsMax}) {
      bottom: ${cssSpacing('tighter')};
      left: ${cssSpacing('tighter')};
    }

    @media (max-width: ${screenSmMax}) {
      bottom: ${cssSpacing('base')};
      left: ${cssSpacing('base')};
    }
  }

  /* Hover effects for interactive feedback */
  &:hover {
    img,
    svg {
      /* Scale up both image and play icon on hover */
      ${transformScaleUp};
      transition: transform 0.3s ease-in-out;
    }
    svg {
      /* Slightly reduce opacity of play icon on hover for visual feedback */
      opacity: 0.8;
    }
  }
`;
